import React from 'react';
import {classes} from './SkeletonLineWrapper.st.css';
import {SkeletonLine} from '@wix/wix-ui-tpa/cssVars';

interface SkeletonLineProps {
  size?: string;
  className?: string;
  dataHook?: string;
}

export const SkeletonLineWrapper = ({size, dataHook, className}: SkeletonLineProps) => {
  return <SkeletonLine data-hook={dataHook} className={size ? classes[size] : className} />;
};
